import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plus-1RWS2",
  "use": "plus-1RWS2-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol stroke-linecap=\"round\" stroke-linejoin=\"round\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"plus-1RWS2\"><path d=\"M12 5v14M5 12h14\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol